import { Code, ConnectError } from "@connectrpc/connect";

import { ERROR_MESSAGES } from "@/api/constants";

/**
 * Get a user-friendly error message from a ConnectError
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof ConnectError) {
    return error.rawMessage || ERROR_MESSAGES[error.code] || "An error occurred";
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "An unexpected error occurred";
}

/**
 * Check if error is a specific Connect error code
 */
export function isConnectError(error: unknown, code: Code): boolean {
  return error instanceof ConnectError && error.code === code;
}

/**
 * Check if error is an authentication error
 */
export function isAuthError(error: unknown): boolean {
  return isConnectError(error, Code.Unauthenticated);
}

/**
 * Check if error is a not found error
 */
export function isNotFoundError(error: unknown): boolean {
  return isConnectError(error, Code.NotFound);
}

/**
 * Check if error is a permission denied error
 */
export function isPermissionError(error: unknown): boolean {
  return isConnectError(error, Code.PermissionDenied);
}

/**
 * Extract error details from ConnectError
 */
export function getErrorDetails(error: unknown): {
  code: string;
  message: string;
  details?: unknown[];
} | null {
  if (error instanceof ConnectError) {
    return {
      code: Code[error.code],
      message: getErrorMessage(error),
      details: error.details,
    };
  }
  return null;
}
